import { render, staticRenderFns } from "./TabPosturas.vue?vue&type=template&id=3fd94007&scoped=true"
import script from "./TabPosturas.vue?vue&type=script&lang=js"
export * from "./TabPosturas.vue?vue&type=script&lang=js"
import style0 from "./TabPosturas.vue?vue&type=style&index=0&id=3fd94007&prod&lang=scss&scoped=true"
import style1 from "./TabPosturas.vue?vue&type=style&index=1&id=3fd94007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd94007",
  null
  
)

export default component.exports